import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { useAuth } from '../../context/AuthContext';
import { useSettings } from '../../hooks/useSettings';
import { FiGlobe, FiSettings } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const Header = ({ onMenuClick, sidebarOpen }) => {
    const { language, toggleLanguage, t } = useLanguage();
    const { user } = useAuth();
    const { logo } = useSettings();

    return (
        <header className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-20">
            <div className="flex items-center justify-between px-4 md:px-6 py-3">
                {/* Left side - Menu button (mobile only) */}
                <div className="flex items-center">
                    <button
                        onClick={onMenuClick}
                        className="lg:hidden p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            {sidebarOpen ? (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            ) : (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            )}
                        </svg>
                    </button>
                </div>

                {/* Right side - Actions */}
                <div className="flex items-center space-x-3">
                    {/* Language Toggle */}
                    <button
                        onClick={toggleLanguage}
                        className="flex items-center space-x-2 px-3 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
                        title={t('header.languageToggle')}
                    >
                        <FiGlobe className="w-5 h-5" />
                        <span className="hidden sm:inline text-sm font-medium">
                            {language === 'en' ? 'मराठी' : 'English'}
                        </span>
                    </button>

                    {/* Settings (Admin only) */}
                    {user?.role === 'admin' && (
                        <Link
                            to="/settings"
                            className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                            title={t('sidebar.settings')}
                        >
                            <FiSettings className="w-5 h-5" />
                        </Link>
                    )}

                    {/* User Avatar */}
                    <div className="flex items-center space-x-3 pl-3 border-l border-gray-200">
                        <div className="hidden sm:block text-right">
                            <p className="text-sm font-medium text-gray-800">
                                {user?.name}
                            </p>
                            <p className="text-xs text-gray-500">
                                {t(user?.role === 'admin' ? 'header.administrator' : 'header.staff')}
                            </p>
                        </div>
                        <div className="w-9 h-9 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full flex items-center justify-center text-white font-semibold text-sm shadow">
                            {user?.name?.charAt(0).toUpperCase()}
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;